<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
                        <a href="#">其他資訊</a>
                    </router-link>
                    <li class="breadcrumb-item active">
                        地圖額外掉落
                    </li>
                </ol>
            </nav>
            <div class="item-box">
                <h3 class="item-title">
                    地圖額外掉落
                </h3>
                <p>地圖37章節以後新增一個通關後的隨機掉落</p>
                <p>因裝備同步功能此頁面不再維護</p>
                <p>This page is no longer maintained due to the equipment synchronization function</p>
                <div class="my-3">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item m-1" v-for="(item, index) in mapList">
                            <button class="pcbtn" :class="index + 1 == mapLength ? 'active' : ''" role="tab"
                                :aria-selected="index + 1 == mapLength ? 'true' : 'false'" data-toggle="pill"
                                :id="'nav-' + replaceDot(item) + '-tab'" :href="'#nav-' + replaceDot(item)"
                                :aria-controls="'nav-' + replaceDot(item)" style="min-width: 100px">
                                Map {{ replaceDot(item) }}
                            </button>
                        </li>
                    </ul>
                    <div class="tab-content p-3" id="nav-tabContent" style="background: none">
                        <div v-for="(map, key, index) in extraDrop" class="tab-pane fade"
                            :class="index + 1 == mapLength ? 'active show' : ''" :id="'nav-' + replaceDot(key)"
                            role="tabpanel" :aria-labelledby="'nav-' + replaceDot(key) + '-tab'">
                            <h3 class="item-title" :id="replaceDot(key)">{{ replaceDot(key) }}</h3>
                            <div class="d-flex flex-wrap justify-content-start">
                                <div class="itemBox col-4 col-lg-1 col-md-2 p-2 anm-grow text-center"
                                    v-for="(item, index) in map">
                                    <router-link
                                        :to="{ name: 'EquipmentDetail', params: { id: getEqName(item.eq_craft) } }">
                                        <img class="img-fluid"
                                            v-lazy="'/static/images/equipment/icon_equipment_' + item.eq_craft + '.png'" />
                                        {{ getEqName(item.eq_craft) }}
                                    </router-link>
                                    <!-- {{ getEqName(item.eq_craft) }} -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ExtraDrop from "../../assets/edata/extraDrop.json";
export default {
    name: "EquipmentReduce",
    metaInfo: {
        title: "地圖額外掉落",
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
        meta: [{ name: "description", content: "地圖37章節以後新增一個通關後的隨機掉落" }],
    },
    data() {
        return {
            extraDrop: ExtraDrop,
            mapList: [],
            mapLength: 1,
        };
    },
    created: function () {
        var self = this;
        _.forEach(ExtraDrop, (o, key, index) => {
            self.mapList.push(key);
        });
        this.mapLength = self.mapList.length;
    },
    computed: {},
    methods: {
        replaceDot: function (number) {
            return number.toString().replace(".", "-");
        },
        getEqName: function (eq_id) {
            var self = this;
            try {
                var eq = _.find(self.$store.getters.getEquipmentCraft, function (o) {
                    return o.condition_equipment_id_1 == eq_id;
                });
                if (eq) {
                    var eqData = _.find(self.$store.getters.getEquipmentData, function (o) {
                        return o.equipment_id == eq.equipment_id;
                    });
                    return eqData.equipment_name;
                } else {
                    var eqData = _.find(self.$store.getters.getEquipmentData, function (o) {
                        return o.equipment_id == eq_id;
                    });
                    return eqData.equipment_name;
                }
            } catch (e) {
                console.log(e, eq_id);
            }
        },
    },
    mounted: function () { },
};
</script>
<style scoped></style>
